export default {
  // common
  ok: 'Tamam',
  cancel: 'İptal',
  send: 'Gönder',
  // time
  timeJustNow: 'Az önce',
  timeMinutesAgo: '{n} dk önce',
  timeHoursAgo: '{n} sa önce',
  timeYesterday: 'Dün',
  // chat toolbar titles
  chatEmotion: 'Emoji',
  chatSendImage: 'Görsel gönder',
  chatSendFile: 'Dosya gönder',
  chatReceipt: 'Alındı mesajı',
  chatSendVoice: 'Sesli gönder',
  chatGroupInfo: 'Grup bilgisi',
  // chat area
  chatSomeoneAtMe: 'Biri benden bahsetti',
  chatNewMessages: '{n} yeni mesaj',
  chatBackToBottom: 'En alta dön',
  chatReceiptPrefix: '[Alındı] ',
  // message actions / tips
  chatNoMoreMessages: 'Daha fazla mesaj yok',
  chatDeleteConfirm: 'Bu mesaj silinsin mi?',
  chatDeleteTitle: 'Mesajı sil',
  chatRecallConfirm: 'Bu mesaj geri çekilsin mi?',
  chatRecallTitle: 'Mesajı geri çek',
  chatRecalled: 'Mesaj geri çekildi',
  chatLocateFail: 'Orijinal mesaj bulunamıyor',
  chatResendUnsupported: 'Bu mesaj otomatik yeniden göndermeyi desteklemiyor. Lütfen manuel olarak yeniden gönderin.',
  // input disabled tips
  chatGroupDissolved: 'Grup dağıtıldı',
  chatGroupQuit: 'Artık bu grupta değilsiniz',
  chatGroupBanned: 'Grup yasaklandı',
  chatUserBanned: 'Bu hesap yasaklandı',
  chatBanReason: ', sebep: ',
  // message status / readed
  msgReaded: 'Okundu',
  msgUnread: 'Okunmadı',
  msgAllReaded: 'Tümü okundu',
  msgSomeReaded: '{n} kişi okudu',
  msgSending: 'Gönderiliyor',
  msgSendFail: 'Gönderim başarısız',
  msgRecall: 'Tekrar ara',
  msgMenuDelete: 'Sil',
  msgMenuRecall: 'Geri çek',
  // voice record
  recordTitle: 'Ses Kaydı',
  recordDuration: 'Süre',
  recordStart: 'Başla',
  recordPause: 'Duraklat',
  recordResume: 'Devam Et',
  recordStop: 'Durdur',
  recordPlay: 'Oynat',
  recordStopPlay: 'Oynatmayı Durdur',
  recordRestart: 'Yeniden Kaydet',
  recordSend: 'Şimdi Gönder',
  recordStateReady: 'Başlamadı',
  recordStateRunning: 'Kaydediliyor...',
  recordStatePaused: 'Kayıt duraklatıldı',
  recordStateStopped: 'Kayıt durduruldu',
  msgReadedTab: 'Okundu ({n})',
  msgUnreadTab: 'Okunmadı ({n})',
  // language
  langLabel: 'Dil',
  langZh: '中文',
  langEn: 'English'
}
